<template>
  <section class="home">
    <div class="slides-container">
      <div
        id="carouselExampleCaptions"
        class="carousel slide"
        data-bs-ride="carousel"
      >
        <div class="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <div class="row">
              <div class="content col-md-6">
                <span>new arrivals</span>
                <h3>flexible chair</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Consequatur quisquam, magnam enim sed debitis perspiciatis.
                </p>
                <router-link to="" class="btn">shop now</router-link>
              </div>
              <div class="image col-md-6">
                <img :src="newOne" alt="" />
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="row">
              <div class="content col-md-6">
                <span>new arrivals</span>
                <h3>flexible chair</h3>
                <p>
                  Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                  Consequatur quisquam, magnam enim sed debitis perspiciatis.
                </p>
                <router-link to="" class="btn">shop now</router-link>
              </div>
              <div class="image col-md-6">
                <img :src="newTwo" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleCaptions"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
    <div class="banner-container">
      <Banner />
    </div>
  </section>
</template>

<script>
import Banner from "../components/Banner";
export default {
  data() {
    return {
      newOne: require("@/images/home-img-1.png"),
      newTwo: require("@/images/home-img-2.png"),
    };
  },
  components: {
    Banner,
  },
};
</script>

